export default "__VITE_ASSET__DJ2p4xWQ__"